import React, {
    useState,
    forwardRef,
    useImperativeHandle,
    useRef,
} from "react"
import TextInput from "../TextInput"
import LocationSelector from "../LocationInput"

const AddressFields = forwardRef(({ data, readOnly }, ref) => {
    const [error, setError] = useState(false)

    const addressLine1Ref = useRef()
    const addressLine2Ref = useRef()
    const addressLine3Ref = useRef()
    const locationRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const addressLine1Data = addressLine1Ref.current.validateAndGetData()
            const addressLine2Data = addressLine2Ref.current.validateAndGetData()
            const addressLine3Data = addressLine3Ref.current.validateAndGetData()
            const locationData = locationRef.current.validateAndGetData()

            const validity =
                addressLine1Data.isValid &&
                addressLine2Data.isValid &&
                addressLine3Data.isValid &&
                locationData.isValid

            setError(!validity)

            const value = {
                addressLine1: addressLine1Data.value,
                addressLine2: addressLine2Data.value,
                addressLine3: addressLine3Data.value,
                ...locationData.value,
            }

            return { isValid: validity, value }
        },
    }))

    return (
        <div className="my-4">

            <div className="mb-4">
                <TextInput
                    title="Address Line 1"
                    ref={addressLine1Ref}
                    data={data?.addressLine1}
                    validator={(val) => val.trim().length > 0}
                    errorMessage="Address Line 1 is required"
                    placeholder="e.g., Street, House/Building Number, Building Name, Flat/Unit"
                    disabled={readOnly}
                    isMandatory={true}
                />
            </div>

            <div className="mb-4">
                <TextInput
                    title="Address Line 2"
                    ref={addressLine2Ref}
                    data={data?.addressLine2}
                    placeholder="e.g., Sub-locality, District, Block"
                    disabled={readOnly}
                />
            </div>

            <div className="mb-4">
                <TextInput
                    title="Address Line 3 (Optional)"
                    ref={addressLine3Ref}
                    data={data?.addressLine3}
                    placeholder="Further administrative details if needed"
                    disabled={readOnly}
                />
            </div>

            <div className="mb-4">
                <LocationSelector
                    ref={locationRef}
                    readonly={readOnly}
                    data={{
                        country: data?.country,
                        state: data?.state,
                        city: data?.city,
                        zipCode: data?.zipCode,
                    }}
                />
            </div>

            {error && (
                <p className="text-red-600 text-sm mt-2">
                </p>
            )}
        </div>
    )
})

export default AddressFields
